/**
 * CHECKBOX remove attribute checked
 */

const checkBox = () => {
  // Select all radio input elements with the specified class name
  const radioInputs = document.querySelectorAll('input.radio-toggle');

  radioInputs.forEach(input => {
    if ((input as HTMLInputElement).checked) {
      // Remove the checked attribute
      input.removeAttribute('checked');
    }
  });
};

export default checkBox;